// @flow
import createGetContent from './createGetContent';

const getSecondOpinionContent = createGetContent('content/secondOpinion');

export default getSecondOpinionContent;



// WEBPACK FOOTER //
// ./src/api/content/getSecondOpinionContent.js